import React, { useState } from "react";
import { NavLink, Outlet, useLocation } from "react-router-dom";
import { signOut } from "firebase/auth";
import { auth } from "./firebase";

export default function DistributorLayout() {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  const getPageTitle = () => {
    const path = location.pathname;
    if (path === "/") return "Tableau de bord";
    if (path.includes("/products")) return "Produits";
    if (path.includes("/orders")) return "Commandes";
    if (path.includes("/vendeurs")) return "Vendeurs";
    if (path.includes("/clients")) return "Clients";
    if (path.includes("/sold-products")) return "Statistiques";
    return "Komondi Pro";
  };

  return (
    <>
      {/* Header */}
      <header style={styles.header}>
        {/* Logo et titre à gauche */}
        <div style={styles.logoContainer}>
          <div style={styles.logoIcon}>📦</div>
          <div>
            <h1 style={styles.logoTitle}>Komondi Pro</h1>
            <p style={styles.logoSubtitle}>Espace Professionnel</p>
          </div>
        </div>

        {/* Menu burger pour mobile */}
        <button 
          style={styles.menuButton}
          onClick={() => setMenuOpen(!menuOpen)}
        >
          {menuOpen ? "✕" : "☰"}
        </button>

        {/* Navigation centrale */}
        <nav style={{
          ...styles.nav,
          display: menuOpen ? 'flex' : 'none',
          ...(window.innerWidth > 768 && { display: 'flex' })
        }}>
          <NavLink 
            to="/" 
            end 
            style={({ isActive }) => ({
              ...styles.navLink,
              ...(isActive && styles.navLinkActive)
            })}
          >
            <span style={styles.navIcon}>📊</span>
            Tableau de bord
          </NavLink>

          <NavLink 
            to="/products" 
            style={({ isActive }) => ({
              ...styles.navLink,
              ...(isActive && styles.navLinkActive)
            })}
          >
            <span style={styles.navIcon}>📦</span>
            Produits
          </NavLink>

          <NavLink 
            to="/orders" 
            style={({ isActive }) => ({
              ...styles.navLink,
              ...(isActive && styles.navLinkActive)
            })}
          >
            <span style={styles.navIcon}>🛒</span>
            Commandes
          </NavLink>

          <NavLink 
            to="/vendeurs" 
            style={({ isActive }) => ({
              ...styles.navLink,
              ...(isActive && styles.navLinkActive)
            })}
          >
            <span style={styles.navIcon}>👥</span>
            Vendeurs
          </NavLink>

          <NavLink 
            to="/clients" 
            style={({ isActive }) => ({
              ...styles.navLink,
              ...(isActive && styles.navLinkActive)
            })}
          >
            <span style={styles.navIcon}>🤝</span>
            Clients
          </NavLink>

          <NavLink 
            to="/sold-products" 
            style={({ isActive }) => ({
              ...styles.navLink,
              ...(isActive && styles.navLinkActive)
            })}
          >
            <span style={styles.navIcon}>📈</span>
            Statistiques
          </NavLink>
        </nav>

        {/* زر الخروج فقط في أقصى اليمين */}
        <button
          onClick={() => signOut(auth)}
          style={styles.logoutButton}
          title="Déconnexion"
        >
          <span style={styles.logoutIcon}>🚪</span>
          <span style={styles.logoutText}>Déconnexion</span>
        </button>
      </header>

      {/* Breadcrumb (fil d'Ariane) */}
      <div style={styles.breadcrumb}>
        <span style={styles.breadcrumbItem}>Accueil</span>
        <span style={styles.breadcrumbSeparator}>›</span>
        <span style={styles.breadcrumbItemActive}>{getPageTitle()}</span>
      </div>

      {/* Contenu principal */}
      <main style={styles.main}>
        <Outlet />
      </main>
    </>
  );
}

// Styles organisés et professionnels
const styles = {
  header: {
    height: '80px',
    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0 32px',
    boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
    position: 'sticky',
    top: 0,
    zIndex: 1000,
    flexWrap: 'wrap'
  },
  logoContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    minWidth: '200px'
  },
  logoIcon: {
    fontSize: '32px',
    background: 'rgba(255,255,255,0.2)',
    width: '48px',
    height: '48px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '12px'
  },
  logoTitle: {
    fontSize: '20px',
    fontWeight: '600',
    color: 'white',
    margin: 0,
    lineHeight: 1.2
  },
  logoSubtitle: {
    fontSize: '12px',
    color: 'rgba(255,255,255,0.8)',
    margin: 0
  },
  menuButton: {
    display: 'none',
    background: 'transparent',
    border: '1px solid rgba(255,255,255,0.3)',
    color: 'white',
    fontSize: '24px',
    padding: '8px 16px',
    borderRadius: '8px',
    cursor: 'pointer'
  },
  nav: {
    display: 'flex',
    gap: '8px',
    background: 'rgba(255,255,255,0.1)',
    padding: '4px',
    borderRadius: '12px',
    backdropFilter: 'blur(10px)',
    flex: 1,
    justifyContent: 'center',
    margin: '0 20px'
  },
  navLink: {
    padding: '10px 16px',
    borderRadius: '8px',
    color: 'rgba(255,255,255,0.9)',
    textDecoration: 'none',
    fontSize: '14px',
    fontWeight: '500',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    transition: 'all 0.2s ease',
    whiteSpace: 'nowrap'
  },
  navLinkActive: {
    background: 'white',
    color: '#667eea',
    boxShadow: '0 4px 12px rgba(0,0,0,0.15)'
  },
  navIcon: {
    fontSize: '16px'
  },
  logoutButton: {
    background: 'rgba(239, 68, 68, 0.9)',
    border: 'none',
    borderRadius: '10px',
    padding: '10px 16px',
    color: 'white',
    fontSize: '14px',
    fontWeight: '500',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    transition: 'all 0.2s ease',
    minWidth: '130px',
    justifyContent: 'center'
  },
  logoutIcon: {
    fontSize: '16px'
  },
  logoutText: {
    '@media (max-width: 768px)': {
      display: 'none'
    }
  },
  breadcrumb: {
    padding: '16px 32px',
    background: '#f8fafc',
    borderBottom: '1px solid #e2e8f0',
    fontSize: '14px'
  },
  breadcrumbItem: {
    color: '#64748b'
  },
  breadcrumbItemActive: {
    color: '#0f172a',
    fontWeight: '500'
  },
  breadcrumbSeparator: {
    margin: '0 8px',
    color: '#94a3b8'
  },
  main: {
    padding: '24px',
    background: '#f8fafc',
    minHeight: 'calc(100vh - 80px - 53px)'
  }
};

// Media queries للتجاوب مع الموبايل
const mediaStyles = document.createElement('style');
mediaStyles.textContent = `
  @media (max-width: 1024px) {
    .nav { display: none; }
    .menuButton { display: block; }
    .logoutText { display: none; }
    .logoutButton { min-width: auto; padding: 10px; }
  }
`;
document.head.appendChild(mediaStyles);